var render = function render(){var _vm=this,_c=_vm._self._c;return _c('StandardIconBloc',{attrs:{"icon":"question-circle-fill","backColor":"rgb(222,235,255)","frontColor":"rgb(0,82,204)"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }